module.exports = __webpack_public_path__ + "media/images/video/stride-go-logo-129cb29fbe6a4ffc4e385bd46152844b.png";